"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeFromString = exports.LOCALE_INFO = exports.localeInfo = exports.LOCALE = void 0;
const monet_1 = require("monet");
const config_1 = require("../config");
const DEPLOY_ENV = config_1.deployEnv;
exports.LOCALE = config_1.locale;
/** Price channels for each locale and environment */
const priceChannels = {
    UK: {
        development: '1bfff3c2-3c0d-4ad2-9a02-1917f2918c9b',
        prd: '78389942-d07e-49ea-b6db-d9880399b866',
        qa: '1bfff3c2-3c0d-4ad2-9a02-1917f2918c9b',
        stg: '99b7e451-fd77-4355-842a-d5c4f5a72ca9'
    },
    US: {
        development: '769db2fd-1900-455c-826a-062b72e16936',
        prd: 'ac57a074-b417-40c1-b592-6e51b9f60cfc',
        qa: '769db2fd-1900-455c-826a-062b72e16936',
        stg: 'eeb5e09e-5f2a-4062-b69c-1c1dfd105b5a'
    }
};
/**
 * Country, currency, domain and price channel for each locale
 */
exports.localeInfo = {
    'en-GB': {
        alpha3Code: 'GBR',
        country: 'GB',
        countryName: 'United Kingdom',
        currency: 'GBP',
        domain: 'uk',
        plaStrikeThroughKey: 'plaDiscountGroup-UK',
        priceChannel: priceChannels.UK[DEPLOY_ENV],
        site: 'simplisafe.co.uk',
        strikeThroughKey: 'discountGroup-UK',
        strikeThroughKeyWithServicePlan: 'discountGroupService-UK'
    },
    'en-US': {
        alpha3Code: 'USA',
        country: 'US',
        countryName: 'United States',
        currency: 'USD',
        domain: 'us',
        plaStrikeThroughKey: 'plaDiscountGroup-US',
        priceChannel: priceChannels.US[DEPLOY_ENV],
        site: 'simplisafe.com',
        strikeThroughKey: 'discountGroup-US',
        strikeThroughKeyWithServicePlan: 'discountGroupService-US'
    }
};
/**
 * To get the locale info for the configured environment locale variable.
 */
exports.LOCALE_INFO = exports.localeInfo[exports.LOCALE];
const localeMapper = {
    'en-GB': 'en-GB',
    'en-US': 'en-US'
};
const localeFromString = (value) => monet_1.Maybe.fromUndefined(value ? localeMapper[value] : undefined);
exports.localeFromString = localeFromString;
//# sourceMappingURL=locale.js.map